import config from '../config';
import aaveSwapABI from './json/aave/swap';
import paaveRewardsabi from './json/paave/rewards';
import atriCryptoSwap from './json/atricrypto/swap';
import atriCryptoZap from './json/atricrypto/zap';
import atriCrypto2Swap from './json/atricrypto2/swap';
import atriCrypto2Zap from './json/atricrypto2/zap';
import renSwapABI from './json/ren-polygon/swap';
import atriCrypto3Swap from './json/atricrypto2/swap';
import atriCrypto3Zap from './json/atricrypto2/zap';
import Plain2Basic from './json/factory-v2/Plain2Basic';
import Plain2BasicEMA from './json/factory-v2/Plain2BasicEMA';
import Plain2Balances from './json/factory-v2/Plain2Balances';
import Plain2ETH from './json/factory-v2/Plain2ETH';
import Plain2ETHEMA from './json/factory-v2/Plain2ETHEMA';
import Plain2Optimized from './json/factory-v2/Plain2Optimized';
import Plain3Basic from './json/factory-v2/Plain3Basic';
import Plain3Balances from './json/factory-v2/Plain3Balances';
import Plain3ETH from './json/factory-v2/Plain3ETH';
import Plain3Optimized from './json/factory-v2/Plain3Optimized';
import Plain4Basic from './json/factory-v2/Plain4Basic';
import Plain4Balances from './json/factory-v2/Plain4Balances';
import Plain4ETH from './json/factory-v2/Plain4ETH';
import Plain4Optimized from './json/factory-v2/Plain4Optimized';
import DepositZapFantom from './json/factory-v2/DepositZapFantom';
import MetaUSD from './json/factory-v2/MetaUSD';
import MetaUSDBalances from './json/factory-v2/MetaUSDBalances';
import MetaBTC from './json/factory-v2/MetaBTC';
import MetaBTCBalances from './json/factory-v2/MetaBTCBalances';

import eurusdSwap from './json/eurusd/swap';
import eurusdZap from './json/eurusd/zap';
import eursusdSwap from './json/eursusd-polygon/swap';
import eursusdZap from './json/eursusd-polygon/zap';


const infura_url = config.rpcUrl;

//rinkeby multicall 0x0ae6578785868f88478B6bCe8227d6F85703092b
const multicall_address = '0x3eF6A01A0f81D6046290f3e2A8c5b843e738E604';

const poolsData = {
    aave: {
        N_COINS: 3,
        is_aave: true,
        coin_precisions: [1e18, 1e6, 1e6],
        wrapped_precisions: [1e18, 1e6, 1e6],
        use_lending: [false, false, false],
        tethered: [false, false, true],
        is_plain: [false, false, false],
        swap_address: '0x445FE580eF8d70FF569aB36e80c647af338db351',
        token_address: '0xE7a24EF0C5e95Ffb0f6684b813A78F2a3AD7D171',
        gauge_address: '0x19793B454D3AfC7b454F206Ffe95aDE26cA6912c',
        old_gauge: '0xe381C25de995d62b453aF8B931aAc84fcCaa7A62',
        underlying_coins: [
            '0x8f3cf7ad23cd3cadbd9735aff958023239c6a063',
            '0x2791bca1f2de4661ed88a30c99a7a9449aa84174',
            '0xc2132d05d31c914a87c6611c10748aeb04b58e8f',
        ],
        coins: [
            '0x27F8D03b3a2196956ED754baDc28D73be8830A6e',
            '0x1a13F4Ca1d028320A707D99520AbFefca3998b7F',
            '0x60D55F02A771d515e077c9C2403a1ef324885CeC',
        ],
        swap_abi: aaveSwapABI,
        sCurveRewards_abi: paaveRewardsabi,
        sCurveRewards_address: '0xBdFF0C27dd073C119ebcb1299a68A6A92aE607F0',
        reward_token: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
    },
    atricrypto: {
        swap_abi: atriCryptoSwap,
        deposit_abi: atriCryptoZap,
        N_COINS: 5,
        REAL_COINS: 3, //cause this is a fake plain pool
        coin_precisions: [1e18, 1e6, 1e6, 1e8, 1e18],
        wrapped_precisions: [1e18, 1e8, 1e18],
        real_precisions: [1e18, 1e8, 1e18],
        tethered: [false, false, false, false, false],
        use_lending: [false, false, false, false, false],
        is_plain: [true, true, true, true, true],
        swap_address: '0x751B1e21756bDbc307CBcC5085c042a0e9AaEf36',
        token_address: '0x8096ac61db23291252574D49f036f0f9ed8ab390',
        gauge_address: '0xb0a366b987d77b5eD5803cBd95C80bB6DEaB48C0',
        deposit_address: '0x3FCD5De6A9fC8A99995c406c77DDa3eD7E406f81',
        pool_type: 'crypto',
        base_pool: 'aave',
        underlying_coins: [
          '0x8f3cf7ad23cd3cadbd9735aff958023239c6a063', //DAI
          '0x2791bca1f2de4661ed88a30c99a7a9449aa84174', // USDC
          '0xc2132d05d31c914a87c6611c10748aeb04b58e8f', //usdt
          '0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6', //WBTC
          '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619', //WETH
        ],
        coins: [
          '0x8f3cf7ad23cd3cadbd9735aff958023239c6a063', //DAI
          '0x2791bca1f2de4661ed88a30c99a7a9449aa84174', // USDC
          '0xc2132d05d31c914a87c6611c10748aeb04b58e8f', //usdt
          '0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6', //WBTC
          '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619', //WETH
        ],
    },
    ren: {
        N_COINS: 2,
        is_aave: true,
        coin_precisions: [1e8, 1e8],
        wrapped_precisions: [1e8, 1e8],
        use_lending: [true, false],
        tethered: [false, false],
        is_plain: [false, true],
        swap_address: '0xC2d95EEF97Ec6C17551d45e77B590dc1F9117C67',
        token_address: '0xf8a57c1d3b9629b77b6726a042ca48990A84Fb49',
        gauge_address: '0xffbACcE0CC7C19d46132f1258FC16CF6871D153c',
        old_gauge: '0x93b14f53528a59e655d8ce39bdba443dcddddc4c',
        underlying_coins: [
            '0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6',
            '0xDBf31dF14B66535aF65AaC99C32e9eA844e14501',
        ],
        coins: [
          '0x5c2ed810328349100A66B82b78a1791B101C9D61',
          '0xDBf31dF14B66535aF65AaC99C32e9eA844e14501',
        ],
        swap_abi: renSwapABI
    },
    atricrypto2: {
        swap_abi: atriCrypto2Swap,
        deposit_abi: atriCrypto2Zap,
        N_COINS: 5,
        REAL_COINS: 3, //cause this is a fake plain pool
        coin_precisions: [1e18, 1e6, 1e6, 1e8, 1e18],
        wrapped_precisions: [1e18, 1e8, 1e18],
        real_precisions: [1e18, 1e8, 1e18],
        tethered: [false, false, false, false, false],
        use_lending: [false, false, false, false, false],
        is_plain: [true, true, true, true, true],
        swap_address: '0x92577943c7aC4accb35288aB2CC84D75feC330aF',
        token_address: '0xbece5d20A8a104c54183CC316C8286E3F00ffC71',
        gauge_address: '0x9bd996Db02b3f271c6533235D452a56bc2Cd195a',
        deposit_address: '0x3Fa8ebd5d16445b42e0b6A54678718C94eA99aBC',
        pool_type: 'crypto',
        base_pool: 'aave',
        underlying_coins: [
          '0x8f3cf7ad23cd3cadbd9735aff958023239c6a063', //DAI
          '0x2791bca1f2de4661ed88a30c99a7a9449aa84174', // USDC
          '0xc2132d05d31c914a87c6611c10748aeb04b58e8f', //usdt
          '0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6', //WBTC
          '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619', //WETH
        ],
        coins: [
          '0x8f3cf7ad23cd3cadbd9735aff958023239c6a063', //DAI
          '0x2791bca1f2de4661ed88a30c99a7a9449aa84174', // USDC
          '0xc2132d05d31c914a87c6611c10748aeb04b58e8f', //usdt
          '0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6', //WBTC
          '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619', //WETH
        ],
    },
    atricrypto3: {
        swap_abi: atriCrypto3Swap,
        deposit_abi: atriCrypto3Zap,
        N_COINS: 5,
        REAL_COINS: 3, //cause this is a fake plain pool
        coin_precisions: [1e18, 1e6, 1e6, 1e8, 1e18],
        wrapped_precisions: [1e18, 1e8, 1e18],
        real_precisions: [1e18, 1e8, 1e18],
        tethered: [false, false, false, false, false],
        use_lending: [false, false, false, false, false],
        is_plain: [true, true, true, true, true],
        swap_address: '0x92215849c439E1f8612b6646060B4E3E5ef822cC',
        token_address: '0xdAD97F7713Ae9437fa9249920eC8507e5FbB23d3',
        gauge_address: '0x3B6B158A76fd8ccc297538F454ce7B4787778c7C',
        deposit_address: '0x1d8b86e3D88cDb2d34688e87E72F388Cb541B7C8',
        pool_type: 'crypto',
        base_pool: 'aave',
        underlying_coins: [
          '0x8f3cf7ad23cd3cadbd9735aff958023239c6a063', //DAI
          '0x2791bca1f2de4661ed88a30c99a7a9449aa84174', // USDC
          '0xc2132d05d31c914a87c6611c10748aeb04b58e8f', //usdt
          '0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6', //WBTC
          '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619', //WETH
        ],
        coins: [
          '0x8f3cf7ad23cd3cadbd9735aff958023239c6a063', //DAI
          '0x2791bca1f2de4661ed88a30c99a7a9449aa84174', // USDC
          '0xc2132d05d31c914a87c6611c10748aeb04b58e8f', //usdt
          '0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6', //WBTC
          '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619', //WETH
        ],
    },
    eurtusd: {
        N_COINS: 2,
        coin_precisions: [1e6, 1e18],
        wrapped_precisions: [1e6, 1e18],
        tethered: [false, false],
        use_lending: [false, false],
        is_plain: [true, true],
        swap_address: '0xB446BF7b8D6D4276d0c75eC0e3ee8dD7Fe15783A',
        token_address: '0x600743B1d8A96438bD46836fD34977a00293f6Aa',
        gauge_address: '0x40c0e9376468b4f257d15F8c47E5D0C646C28880',
        pool_type: 'crypto',
        base_pool: 'aave',
        underlying_coins: [
            '0x7BDF330f423Ea880FF95fC41A280fD5eCFD3D09f',
            '0xE7a24EF0C5e95Ffb0f6684b813A78F2a3AD7D171',
        ],
        coins: [
            '0x7BDF330f423Ea880FF95fC41A280fD5eCFD3D09f',
            '0xE7a24EF0C5e95Ffb0f6684b813A78F2a3AD7D171',
        ],
        swap_abi: eurusdSwap,
        deposit_abi: eurusdZap,
        deposit_address: '0x225FB4176f0E20CDb66b4a3DF70CA3063281E855',
        base_pool: 'aave',
        is_meta: true,
        meta_N: 5,
        meta_precisions: [1e6, 1e18, 1e18, 1e6, 1e6],
        meta_coin_precisions: [1e6, 1e18, 1e6, 1e6],
        meta_wrapped_precisions: [1e6, 1e18],
        meta_coins: [
            '0x8f3cf7ad23cd3cadbd9735aff958023239c6a063', //DAI
            '0x2791bca1f2de4661ed88a30c99a7a9449aa84174', // USDC
            '0xc2132d05d31c914a87c6611c10748aeb04b58e8f', //usdt
        ],
        all_coins: [
            '0x7BDF330f423Ea880FF95fC41A280fD5eCFD3D09f',
            '0xE7a24EF0C5e95Ffb0f6684b813A78F2a3AD7D171', //base pool lp
            '0x8f3cf7ad23cd3cadbd9735aff958023239c6a063', //DAI
            '0x2791bca1f2de4661ed88a30c99a7a9449aa84174', // USDC
            '0xc2132d05d31c914a87c6611c10748aeb04b58e8f', //usdt
        ]
    },
    eursusd: {
        N_COINS: 2,
        coin_precisions: [1e2, 1e18],
        wrapped_precisions: [1e2, 1e18],
        tethered: [false, false],
        use_lending: [false, false],
        is_plain: [true, true],
        swap_address: '0x9b3d675FDbe6a0935E8B7d1941bc6f78253549B7',
        token_address: '0x7BD9757FbAc089d60DaFF1Fa6bfE3BC99b0F5735',
        gauge_address: '0x40c0e9376468b4f257d15F8c47E5D0C646C28880', // Unrelated gauge address used as placeholder
        pool_type: 'crypto',
        base_pool: 'aave',
        underlying_coins: [
            '0xe111178a87a3bff0c8d18decba5798827539ae99',
            '0xE7a24EF0C5e95Ffb0f6684b813A78F2a3AD7D171',
        ],
        coins: [
            '0xe111178a87a3bff0c8d18decba5798827539ae99',
            '0xE7a24EF0C5e95Ffb0f6684b813A78F2a3AD7D171',
        ],
        swap_abi: eursusdSwap,
        deposit_abi: eursusdZap,
        deposit_address: '0x4DF7eF55E99a56851187822d96B4E17D98A47DeD',
        is_meta: true,
        meta_N: 5,
        meta_precisions: [1e2, 1e18, 1e18, 1e6, 1e6],
        meta_coin_precisions: [1e2, 1e18, 1e6, 1e6],
        meta_wrapped_precisions: [1e2, 1e18],
        meta_coins: [
            '0x8f3cf7ad23cd3cadbd9735aff958023239c6a063', //DAI
            '0x2791bca1f2de4661ed88a30c99a7a9449aa84174', // USDC
            '0xc2132d05d31c914a87c6611c10748aeb04b58e8f', //usdt
        ],
        all_coins: [
            '0xe111178a87a3bff0c8d18decba5798827539ae99',
            '0xE7a24EF0C5e95Ffb0f6684b813A78F2a3AD7D171', //base pool lp
            '0x8f3cf7ad23cd3cadbd9735aff958023239c6a063', //DAI
            '0x2791bca1f2de4661ed88a30c99a7a9449aa84174', // USDC
            '0xc2132d05d31c914a87c6611c10748aeb04b58e8f', //usdt
        ]
    },
};

const factoryPoolDataSkeleton = {
    swap_abi: aaveSwapABI,
    N_COINS: 2, // to fill and replace w/ null in skeleton
    coin_precisions: [1e18, 1e18], // to fill and replace w/ null in skeleton
    wrapped_precisions: [1e18, 1e18], // to fill and replace w/ null in skeleton
    tethered: [false, false], // to fill and replace w/ null in skeleton
    use_lending: [false, false], // to fill and replace w/ null in skeleton
    is_plain: [true, true], // to fill and replace w/ null in skeleton
    swap_address: '0x445FE580eF8d70FF569aB36e80c647af338db351', // to fill and replace w/ null in skeleton
    token_address: '0xE7a24EF0C5e95Ffb0f6684b813A78F2a3AD7D171', // to fill and replace w/ null in skeleton
    gauge_address: '0x19793B454D3AfC7b454F206Ffe95aDE26cA6912c', // Fake pool address to prevent old multicalls from reverting
    underlying_coins: [ // to fill and replace w/ null in skeleton
        '0x5f98805A4E8be255a32880FDeC7F6728C6568bA0',
        '0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490',
    ],
    coins: [ // to fill and replace w/ null in skeleton
        '0x5f98805A4E8be255a32880FDeC7F6728C6568bA0',
        '0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490',
    ],
    deposit_abi: DepositZapFantom,
    deposit_address: '0xA79828DF1850E8a3A3064576f380D90aECDD3359',
    is_meta: true,
    base_pool: 'aave', // to fill and replace w/ null in skeleton
    meta_N: 5, // to fill and replace w/ null in skeleton
    meta_precisions: [1e18, 1e18, 1e18, 1e6, 1e6], // to fill and replace w/ null in skeleton
    meta_coin_precisions: [1e18, 1e18, 1e6, 1e6], // to fill and replace w/ null in skeleton
    meta_wrapped_precisions: [1e18, 1e18], // to fill and replace w/ null in skeleton
    meta_coins: [ // to fill and replace w/ null in skeleton
        '0x6B175474E89094C44Da98b954EedeAC495271d0F',
        '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
        '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    ],
    all_coins: [ // to fill and replace w/ null in skeleton
        '0x5f98805A4E8be255a32880FDeC7F6728C6568bA0',
        '0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490',
        '0x6B175474E89094C44Da98b954EedeAC495271d0F',
        '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
        '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    ],
    is_factory: true,
    sCurveRewards_abi: undefined,
    sCurveRewards_address: undefined,
    reward_token: undefined,
};

export {
    infura_url,
    multicall_address,
    poolsData,
    factoryPoolDataSkeleton,
    Plain2Basic,
    Plain2BasicEMA,
    Plain2Balances,
    Plain2ETH,
    Plain2ETHEMA,
    Plain2Optimized,
    Plain3Basic,
    Plain3Balances,
    Plain3ETH,
    Plain3Optimized,
    Plain4Basic,
    Plain4Balances,
    Plain4ETH,
    Plain4Optimized,
    MetaUSD,
    MetaUSDBalances,
    MetaBTC,
    MetaBTCBalances,
};
